import { CommitmentEventCategoryList } from '../../../components/Commitment';

export function CommitmentEventCategories() {
  return <CommitmentEventCategoryList />;
}
